module.exports = __webpack_public_path__ + "fonts/Alga-LightItalic.8e0f57f5.ttf";